import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ResyRoutes from './ResyRoutes';
import getRouterBasename from './getRouterBasename';

const ResyRouter = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <BrowserRouter basename={getRouterBasename()}>
        <ResyRoutes {...props} />
      </BrowserRouter>
    </Provider>
  );
};

ResyRouter.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default ResyRouter;
